import { render, staticRenderFns } from "./ia-cliente-tarefas.vue?vue&type=template&id=79a0a2a5&scoped=true&"
import script from "./ia-cliente-tarefas.vue?vue&type=script&lang=js&"
export * from "./ia-cliente-tarefas.vue?vue&type=script&lang=js&"
import style0 from "./ia-cliente-tarefas.vue?vue&type=style&index=0&id=79a0a2a5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a0a2a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a0a2a5')) {
      api.createRecord('79a0a2a5', component.options)
    } else {
      api.reload('79a0a2a5', component.options)
    }
    module.hot.accept("./ia-cliente-tarefas.vue?vue&type=template&id=79a0a2a5&scoped=true&", function () {
      api.rerender('79a0a2a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/ia-cliente-painel/ia-cliente-tarefas.vue"
export default component.exports